import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import "./styles.scss";
import SharepointSection, { sharepointLogin } from "./sharepoint";
import SharepointIcon from "../assets/sharepoint-icon.svg"
import { SiteDetailsAction, SiteDetailsReset } from "../../../store/slices/sync-external/siteDetails";
import { message } from "antd";

const SyncExternal = () => {
    const [selectedOption, setSelectedOption] = useState(null)
    const [sharepointAccessToken, setSharepointAccessToken] = useState("")

    const location = useLocation()
    const dispatch = useDispatch()
    const { data: siteDetails, error: siteDetailsError } = useSelector((state) => state?.siteDetails)

    const handleSelectCard = ({ data }) => {
        setSelectedOption(prev => (prev?.key === data?.key ? null : data));
        data?.action()
    }

    const connectOptions = [
        {
            key: 1,
            type: "sharepoint",
            defaultActive: !!sharepointAccessToken,
            icon: {
                type: "image",
                src: SharepointIcon,
                alt: "microsoft-sharepoint-icon"
            },
            title: "Connect with Microsoft Sharepoint",
            action: () => !sharepointAccessToken && sharepointLogin(),
            contents: (<SharepointSection />)
        }
    ]

    useEffect(() => {
        dispatch(SiteDetailsReset())

        dispatch(SiteDetailsAction())
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");

        let connectType = ""

        if (code) {
            connectType = "sharepoint"
        }

        queryParams?.delete("code")
        const matchedOption = connectOptions?.find((opt) => opt?.type === connectType)
        setSelectedOption(matchedOption)

    }, [location])

    useEffect(() => {
        if (siteDetails) {
            setSharepointAccessToken(siteDetails?.data?.sharepoint?.accessToken)
        }
    }, [siteDetails])

    useEffect(() => {
        if (sharepointAccessToken) {
            setSelectedOption(connectOptions[0])
        }
    }, [sharepointAccessToken])

    useEffect(() => {
        if (siteDetailsError?.message) {
            message?.error(siteDetailsError?.message)
        }
    }, [siteDetailsError?.message])

    return (
        <div className="sync-external-section-container">
            <div className="connect-options">
                {connectOptions?.map((option) => (
                    <div className="connect-item-card" key={option?.key} onClick={() => handleSelectCard({ data: option })}>
                        <input
                            type="radio"
                            name="connectOption"
                            value={option.key}
                            checked={selectedOption?.key === option?.key}
                            onChange={() => handleSelectCard({ data: option })}
                        />
                        {option?.icon?.type === "image" && (
                            <img alt={option?.icon?.alt} src={option?.icon?.src} className="connect-item-icon" />
                        )}
                        {option?.title}
                    </div>
                ))}
            </div>
            {selectedOption?.contents && (
                <div className="folder-sections">
                    {selectedOption?.contents}
                </div>
            )}
        </div>
    )
}

export default SyncExternal